import { Box, CircularProgress, Container, Grid, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';


const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

class ConsultasCalificaciones extends Component {
    constructor(props){
        super(props);
        this.state = {
            errores: null,
            notificaciones: null,
            consulta: false,

            busqueda: {
                numeroFuncionario: '',
                anio: '',
            },

            datosConsulta: [],
        }
        this.manejoEnvioNumeroFuncionario = this.manejoEnvioNumeroFuncionario.bind(this);
        this.manejarCambioNumFun = this.manejarCambioNumFun.bind(this);
    }
    render(){
        return (
            <>
                <Container>
                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                    <br/>
                        <div>
                            {this.state.consulta ?
                                <ReactHtmlTableToExcel id="botonExportarExcel" className="btn btn-outline-success" table="tablaConsulta" filename="prueba" sheet="pagina 1" buttonText="Exportar a Excel">
                                </ReactHtmlTableToExcel> : null }
                        </div>
                        <form className='formulario1'  onSubmit={this.manejoEnvioNumeroFuncionario}>
                            <Box sx={{ flexGrow: 1}} >
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2.5}>
                                        <Item>Número de Funcionario</Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='numeroFuncionario' value={this.state.busqueda.numeroFuncionario} onChange={this.manejarCambioNumFun} type="number" /></Item>
                                    </Grid>
                                    <Grid item xs={0.5}>

                                    </Grid>
                                    <Grid item xs={1.5}>
                                        <Item>Año</Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='anio' value={this.state.busqueda.anio} onChange={this.manejarCambioNumFun}/></Item>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <button className="btn btn-outline-primary mx-2" type='submit'>Buscar</button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </form>
                    <br/>
                    {this.state.consulta
                    ?
                        <Container>
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper} >
                                <Table sx={{minWidth: 700}} id="tablaConsulta">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Número</StyledTableCell>
                                            <StyledTableCell>Nombre</StyledTableCell>
                                            <StyledTableCell>Escalafon</StyledTableCell>
                                            <StyledTableCell>Grado</StyledTableCell>
                                            <StyledTableCell>Cargo</StyledTableCell>
                                            <StyledTableCell>Año</StyledTableCell>
                                            <StyledTableCell>Puntaje</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.datosConsulta.map((dato, index) => (
                                            <StyledTableRow key={index}>
                                                <StyledTableCell>{dato.numeroFuncionario}</StyledTableCell>
                                                <StyledTableCell>{dato.nombreFuncionario}</StyledTableCell>
                                                <StyledTableCell>{dato.escalafon}</StyledTableCell>
                                                <StyledTableCell>{dato.grado}</StyledTableCell>
                                                <StyledTableCell>{dato.cargo}</StyledTableCell>
                                                <StyledTableCell>{dato.anio}</StyledTableCell>
                                                <StyledTableCell>{dato.puntaje}</StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Container>
                    :
                        null
                    }
                </Container>
            </>
        )
    }

    async manejoEnvioNumeroFuncionario(e){
        e.preventDefault();
        if((this.state.busqueda.anio === '')){
            this.setState({
                errores: 'Debe ingresar el año de la calificación!',
            })
        }else{
            this.setState({
                errores: null,
                notificaciones: null,
            });
            const cargaUtil = JSON.stringify(this.state.busqueda);

            const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_calificacionesFuncionarios.php`,{
                method: 'POST',
                body: cargaUtil,
            })

            const exito = await respuesta.json();

            this.setState({
                errores: exito[0],
            })
            if(exito[0] === 'ok'){
                this.setState({
                    datosConsulta: exito[1],
                    errores: null,
                    notificaciones: null,
                    consulta: true,
                })
            }
        }
    }

    manejarCambioNumFun(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const numFunActualizado = state.busqueda;
            numFunActualizado[clave] = valor;
            return{
                busqueda: numFunActualizado,
            };
        });
    }
}

export default ConsultasCalificaciones